import React from 'react';

import styled from 'styled-components';

import { useAppSelector } from 'store/hook';

import SidebarMenuCategoryHeader from './SidebarMenuCategoryHeader';
import SidebarMenuItem from './SidebarMenuItem';

const Container = styled.div`
  margin-top: 10px;
`;

const SidebarMenuOther = () => {
  const { currentUser } = useAppSelector((state) => state.auth);

  const showSettings = currentUser?.feature_flags?.show_beta_settings;
  const isAdminUser = Boolean(currentUser?.isSuperuser || currentUser?.isStaff);
  const canViewUserManagement = Boolean(currentUser?.feature_flags?.show_user_management);
  const showUsersItem = Boolean(currentUser && !isAdminUser && canViewUserManagement);

  if (!showSettings && !showUsersItem) {
    return null;
  }

  return (
    <Container>
      <SidebarMenuCategoryHeader title={'OTHER'} />
      {showSettings && <SidebarMenuItem to={'/preferences'} label={'Settings'} />}
      {showUsersItem && <SidebarMenuItem to={'/users'} label={'Users'} />}
    </Container>
  );
};

export default SidebarMenuOther;
